module.exports = __webpack_public_path__ + "ps.182f99ef0b0383dd5360.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ps.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ps.svg
// module chunks = styles